module.exports = __webpack_public_path__ + "static/media/avatar1.a2d15caa.png";